import { CidadaoAtendimentoSelectFieldModel } from 'components/form'
import createDecorator, { Calculation } from 'final-form-calculate'
import { MetaPath, metaPath } from 'util/metaPath'

import {
  AgendamentoConsultaCompartilhadaModel,
  AgendamentoConsultaModel,
  ContatoCidadaoAgendamento,
} from '../model-agenda'

export function createContatoCidadaoAgendamentoCalculation(
  contatoCidadaoPath: MetaPath<ContatoCidadaoAgendamento>
): Calculation {
  return {
    field: contatoCidadaoPath.email.absolutePath(),
    updates: {
      [contatoCidadaoPath.enviarEmail.absolutePath()]: (email: string | null | undefined) => {
        return email ? undefined : false
      },
    },
  }
}

const metaConsulta = metaPath<AgendamentoConsultaModel>()

const agendamentoConsultaCalculations = [
  {
    field: metaConsulta.cidadao.absolutePath(),
    updates: {
      [metaConsulta.contatoCidadao.email.absolutePath()]: (cidadaoValue: CidadaoAtendimentoSelectFieldModel) =>
        cidadaoValue?.contato.email,
      [metaConsulta.contatoCidadao.telefoneCelular.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato.telefoneCelular,
    },
  },
  createContatoCidadaoAgendamentoCalculation(metaConsulta.contatoCidadao),
]

export const agendamentoConsultaDecorator = [createDecorator(...agendamentoConsultaCalculations)]

const metaConsultaCompartilhada = metaPath<AgendamentoConsultaCompartilhadaModel>()

const agendamentoConsultaCompartilhadaCalculations = [
  {
    field: metaConsultaCompartilhada.cidadaoParticipante.cidadao.absolutePath(),
    updates: {
      [metaConsultaCompartilhada.cidadaoParticipante.contato.email.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato?.email,
      [metaConsultaCompartilhada.cidadaoParticipante.contato.telefoneCelular.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => cidadaoValue?.contato?.telefoneCelular,
      [metaConsultaCompartilhada.imprimirAgendamento.absolutePath()]: (
        cidadaoValue: CidadaoAtendimentoSelectFieldModel
      ) => (cidadaoValue ? undefined : false),
    },
  },
  createContatoCidadaoAgendamentoCalculation(metaConsultaCompartilhada.cidadaoParticipante.contato),
]

export const agendamentoConsultaCompartilhadaDecorator = [
  createDecorator(...agendamentoConsultaCompartilhadaCalculations),
]
